<template>
    <div class="d-flex justify-content-between align-items-center w-100">
        <input
            type="text"
            autocomplete="off"
            :id="id || `time-picker-${random}`"
            :list="`data-list-${random}`"
            :value="value"
            @focus="focused = true"
            @blur="focused = false"
            @input="handleInput($event)"
            style="font-size: 90%;"
            @keydown.enter.prevent="() => null"
            :placeholder="placeholder"
            class="px-1 form-control-sm form-control"
            :style="pickerStyle"
            :class="[pickerClass, { 'border-danger': value && value.length && !inputIsValid }]"
        />
        <datalist :id="`data-list-${random}`">
            <option
                class="small"
                v-for="o in datePickerOptionsList"
                :style="focused ? 'display:block' : 'display:none'"
                :value="o"
            ></option>
        </datalist>
        <i
            @click="$emit('input', '')"
            class="fa fa-times text-dark small cursor-pointer p-1"
            v-tooltip="'Clear'"
        ></i>
    </div>
</template>

<script>
export default {
    name: "TimePicker",
    props: [
        "value",
        "id",
        "pickerClass",
        "pickerStyle",
        "optionClass",
        "optionStyle",
        "options",
        "startHour",
        "startMinute",
        "endHour",
        "endMinute",
        "placeholder",
    ],
    data() {
        return {
            random: parseInt(Math.random() * 1e6),
            outputFormat: "HH:mm A",
            pickerFormat: "hh:mm A",
            focused: false,
        };
    },

    computed: {
        inputIsValid() {
            return this.value.match(/^([0-1]?\d|(20|21|22|23)):([0-5]\d)(\s?)([aApP][mM])?/g);
        },
        datePickerOptionsList() {
            const minutesInterval =
                this.options && this.options.minutesInterval ? this.options.minutesInterval : 15;
            const hoursInterval =
                this.options && this.options.hoursInterval ? this.options.hoursInterval : 1;
            //const mode = this.options && this.options.mode ? this.options.mode : 24;
            this.pickerFormat =
                this.options && this.options.pickerFormat ? this.options.pickerFormat : "hh:mm A";
            this.outputFormat =
                this.options && this.options.outputFormat ? this.options.outputFormat : "HH:mm";
            const startHour = this.makeValidHour(this.startHour, false); //Must be in 24-hour
            let endHour = this.makeValidHour(this.endHour, true); //Must be in 24-hour
            let startMinute = this.makeValidMinute(this.startMinute, false);
            let endMinute = this.makeValidMinute(this.endMinute, true);
            if (endHour < startHour) {
                endHour = 23;
            }
            if (endHour === startHour && endMinute < startMinute) {
                endMinute = 59;
            }
            let options = [];
            for (let h = startHour; h <= endHour; h += hoursInterval) {
                if (h === endHour) {
                    for (let m = startMinute; m <= endMinute; m += minutesInterval) {
                        let timeString = `${("0" + h).slice(-2)}:${("0" + m).slice(-2)}`;
                        options.push(this.moment(timeString, "HH:mm").format(this.pickerFormat));
                    }
                } else {
                    for (let m = startMinute; m <= 59; m += minutesInterval) {
                        let timeString = `${("0" + h).slice(-2)}:${("0" + m).slice(-2)}`;
                        options.push(this.moment(timeString, "HH:mm").format(this.pickerFormat));
                    }
                }
                startMinute = 0;
            }
            return options;
        },
    },

    methods: {
        makeValidHour(input, end) {
            const hour = parseInt(input);
            if (end) {
                return isNaN(hour) || hour < 0 || hour > 23 ? 23 : hour;
            }
            return isNaN(hour) || hour < 0 || hour > 23 ? 0 : hour;
        },

        makeValidMinute(input, end) {
            const minute = parseInt(input) - (parseInt(input) % 15); //15 min intervals hard-coded
            if (end) {
                return isNaN(minute) || minute < 0 || minute > 59 ? 59 : minute;
            }
            return isNaN(minute) || minute < 0 || minute > 59 ? 0 : minute;
        },

        handleInput(event) {
            this.$emit("input", event.target.value);
        },
    },
};
</script>
<style scoped lang="scss">
input::placeholder {
    font-style: italic;
    color: #767676;
}

input::-webkit-calendar-picker-indicator:hover {
    background-color: transparent;
}
</style>
